import { render, staticRenderFns } from "./AddEditMainCertificate.vue?vue&type=template&id=7c0ff6d8"
import script from "./AddEditMainCertificate.vue?vue&type=script&lang=js"
export * from "./AddEditMainCertificate.vue?vue&type=script&lang=js"
import style0 from "./AddEditMainCertificate.vue?vue&type=style&index=0&id=7c0ff6d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports